import { render, staticRenderFns } from "./pluck404.vue?vue&type=template&id=4b8636e8&scoped=true"
import script from "./pluck404.vue?vue&type=script&lang=js"
export * from "./pluck404.vue?vue&type=script&lang=js"
import style0 from "./pluck404.vue?vue&type=style&index=0&id=4b8636e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8636e8",
  null
  
)

export default component.exports